import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import ProductItemUnitInfoListRow from "./ProductItemUnitInfoListRow";

const ProductItemUnitInfoList = () => {
  const { showUnitInfos } = useSelector((state) => state.productItemUnit);
  const getStockStatus = (qty, reorderQty) => {
    if (qty <= reorderQty) {
      return { label: "Low Stock", color: "error" };
    } else if (qty <= reorderQty * 2) {
      return { label: "Medium Stock", color: "warning" };
    }
    return { label: "In Stock", color: "success" };
  };

  return (
    <TableContainer>
      <Table stickyHeader aria-label="product item unit info table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
              Branch
            </TableCell>
            <TableCell sx={{ fontWeight: 600, minWidth: 120 }} align="right">
              Purchase Price
            </TableCell>
            <TableCell sx={{ fontWeight: 600, minWidth: 120 }} align="right">
              Selling Price
            </TableCell>
            <TableCell sx={{ fontWeight: 600, minWidth: 100 }} align="right">
              Quantity
            </TableCell>
            <TableCell sx={{ fontWeight: 600, minWidth: 100 }} align="right">
              Reorder Qty
            </TableCell>
            <TableCell sx={{ fontWeight: 600, minWidth: 120 }} align="center">
              Stock Status
            </TableCell>
            <TableCell sx={{ fontWeight: 600, minWidth: 120 }} align="center">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {showUnitInfos?.data?.unitInfos?.length === 0 ? (
            // Empty state when no data
            <TableRow>
              <TableCell colSpan={7} align="center" sx={{ py: 8 }}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    No product item unit info found
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    There are currently no product item unit information
                    available.
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            // Actual data when available
            showUnitInfos?.data?.relatedUnitInfos?.map((row) => (
              <ProductItemUnitInfoListRow key={row._id} row={row} />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProductItemUnitInfoList;
